import { render, staticRenderFns } from "./PainelErrosEntregas.vue?vue&type=template&id=0a3c0a47"
import script from "./PainelErrosEntregas.vue?vue&type=script&lang=js"
export * from "./PainelErrosEntregas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports